exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.table-bordered>tbody>tr>td{\r\n    vertical-align: middle;\r\n    color: black;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/tejashree/src/app/serchreport/serchreport.component.css
// module id = ../../../../../src/app/serchreport/serchreport.component.css
// module chunks = main